import React from 'react';

import '../../stylesheet/bs-stepper.css'
import './SideNav.css';

interface SideNavStepProps{
    label : string;
    image : string;
    isActive : boolean;
    onClick : () => void;
    disabled?: boolean;
}

export default function SideNavStep(props : SideNavStepProps) {
    return <div className="step">
        <button disabled={props.disabled} onClick={props.onClick} type="button" className={"step-trigger justify-content-end" + (props.isActive ? " step-active" : "")} role="tab">
            <span className="bs-stepper-label">{props.label}</span>
            <span className="bs-stepper-circle">
                <img src={props.image} alt={props.label}></img>
            </span>
        </button>
    </div>
}